var $w = $(window);
$w.on('resize',update);

window._h = $w.height()-40;
window._w = $w.width();

function update(){
    window._h = $w.height()-40; // taskbar
    window._w = $w.width();
    $event && $event.emit('window:resize');
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/service/global-var.js
 ** module id = 38
 ** module chunks = 0
 **/